import {postRequest, URL_SERVER} from './../requests'


export async function closeOffer(offerId, token){
    const data = {
        "offer_id": offerId
    }
    try {

        return await postRequest(URL_SERVER + '/closesuccess', data, token)
    } catch (error) {
        console.error(error);
    }

}